import { apiClientPlatform } from "./config";

/**
 * Get list tags
 * THIS API IS ACCESSIBLE ONLY BY ADMIN
 * @param {page, per_page, include[], filter} params
 * @param {function} successCallback
 * @param {function} errorCallback
 * @returns
 */
export const getTagsList = async (
	{ params, config },
	successCallback = false,
	errorCallback = false
) => {
	try {
		const response = await apiClientPlatform.get(`/backoffice/tags`, {
			...config,
			params: params,
		});
		if (successCallback) successCallback(response.data);
		return response.data;
	} catch (error) {
		if (errorCallback) errorCallback(error.response);
		return error;
	}
};
